export default "__VITE_ASSET__4HvvFGb7__"